import React, { Component } from 'react';
import styles from './search-map-container.module.scss';
import './mapbox.scss';
import { connect } from 'react-redux';
import { getQldCouncilsGeo, getIsMobile } from '../../reducers';
import RegionMap from '../region-map';

const DEFAULT_COORDINATES = [-20, 146];

const initialViewport = {
  latitude: DEFAULT_COORDINATES[0],
  longitude: DEFAULT_COORDINATES[1],
  zoom: 4,
  width: 200,
  height: 600,
};

class SearchMapContainer extends Component {
  constructor() {
    super();
    this.state = {
      hoveredCouncil: null,
      tooltipPosition: { x: 0, y: 0 },
      viewState: initialViewport,
      qldCouncilsGeo: null,
    };
  }

  render() {
    return (
      <div
        ref={(d) => {
          this.map = d;
        }}
        className={`searchMapWrapper ${styles.searchMapWrapper}`}
      >
        <RegionMap
          council={null}
          onCouncilSelect={this.props.onCouncilSelect}
          scrollZoom={false}
        />
      </div>
    );
  }
}

export default connect((s) => ({
  qldCouncilsGeo: getQldCouncilsGeo(s),
  isMobile: getIsMobile(s),
}))(SearchMapContainer);



// WEBPACK FOOTER //
// ./src/components/search-map-container/search-map-container.js